import { t } from 'i18next';
import { ApiError } from './ApiError';

export function isAuthenticationError(error: Error): error is AuthenticationError {
  return error.constructor === AuthenticationError;
}

export class AuthenticationError extends ApiError {
  static async create(response: Response) {
    const errorResponse = await this.extractError(response);

    const newError = new AuthenticationError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      t('Error.Category.Unauthorized.message');

    return newError;
  }
}
